import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TableStateService } from '../../../../shared/services/table-state.service';
import { MonitoredTrain, TrainTypeConfiguration } from "../../models/monitored-train";
import { TrainTreeStructurePipe } from '../../pipes/train-tree-structure.pipe';

@Component({
  selector: 'app-monitored-train-devices',
  template: require('./monitored-train-devices.component.html'),
  styles: [require('./monitored-train-devices.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonitoredTrainDevicesComponent implements OnInit, OnChanges, OnDestroy {

  @Input() train: MonitoredTrain;
  @Input() trainTypeConfiguration: TrainTypeConfiguration;

  devices: any[];
  languageChangeSubscription: Subscription;

  tableConfiguration: any = {
    paginate: true,
    sortableMode: 'multiple',
    defaultPagination: 50,
    itemsPerPageOptions: [50,100,250,500],
    globalFilterFields: ['coach.label', 'hostname', 'ipAddr', 'serial', 'config', 'firmware', 'type', 'paintedCoachId', 'position'],
    exportFilename: 'config-status-train-devices-table'
 }

 columns: any[] ;

  constructor(
    private trainTreeStructurePipe: TrainTreeStructurePipe,
    private translate: TranslateService,
    public tableState: TableStateService
  ) { 
    this.languageChangeSubscription = this.translate.onLangChange.subscribe ( () => {
      this._refreshConfigStatusTable();
      this._processDevicesData();
    } );
  }

  ngOnInit(): void {
    this._refreshConfigStatusTable();
  }

  ngOnChanges(): void {
    this._processDevicesData();
  }

  _processDevicesData = () => {
    const trainStructure = this.trainTreeStructurePipe.transform(this.train, this.trainTypeConfiguration);
    if (trainStructure.length > 0) {
      this.devices = trainStructure[0].children ? trainStructure[0].children.reduce((acc: any, coach) => {
        return [
          ...acc,
          ...coach.children?.map(device => {
            return {
              coach: {
                label: coach.label,
                style: coach.data.style
              },
              ...device.data?.device
            }
          })
        ];
      }, []) : []
    }
  }

  _refreshConfigStatusTable = () => {
    this.columns = [{
      header: this.translate.instant('I18N_MONITORING.COACH'),
      field: 'coach.label',
      type: 'text'
    },
    {
      header: this.translate.instant('I18N_MONITORING.DEVICE_ZABBIX_HOST'),
      field: 'hostname',
      type: 'text'
    },
    {
      header: this.translate.instant('I18N_MONITORING.DEVICE_IP_ADDRESS'),
      field: 'ipAddr',
      type: 'text'
    },
    {
      header: this.translate.instant('I18N_MONITORING.DEVICE_SERIAL'),
      field: 'serial',
      type: 'text'
    },
    {
      header: this.translate.instant('I18N_MONITORING.DEVICE_CONFIG'),
      field: 'config',
      type: 'text'
    },
    {
      header: this.translate.instant('I18N_MONITORING.DEVICE_FIRMWARE'),
      field: 'firmware',
      type: 'text'
    },
    {
      header: this.translate.instant('I18N_MONITORING.DEVICE_TYPE'),
      field: 'type',
      type: 'text'
    },
    {
      header: this.translate.instant('I18N_MONITORING.PAINTED_CAR_NUMBER'),
      field: 'paintedCoachId',
      type: 'text'
    },
    {
      header: this.translate.instant('I18N_MONITORING.DEVICE_POSITION'),
      field: 'position',
      type: 'text'
    }, {
      header: this.translate.instant('I18N_GENERAL.ACTIONS'),
      type: null,
      disableSorting: true,
      disableSearch: true
    }]
    
  }

  openDeviceConfiguration = (ev: Event, device: any, linkType: string) => {
    ev.stopPropagation();
    ev.preventDefault();
    window.open(`${linkType}://${device.surfIPAddress}`, "_blank");
  }

  ngOnDestroy(): void {
   this.languageChangeSubscription.unsubscribe();
  }
}
